<h2 mat-dialog-title>
  GL Journal
  <span class="muted-title">
    {{ data.type }} / {{ data.number }}
  </span>
</h2>

<mat-dialog-content class="transaction-detail-content">
  <div class="header-section">
    <div class="header-grid">
      <div class="header-item">
        <div class="label">Period</div>
        <div class="value">
          {{ data.periodno }}
          <span *ngIf="data.periodname">- {{ data.periodname }}</span>
        </div>
      </div>
      <div class="header-item">
        <div class="label">Tran Date</div>
        <div class="value">
          {{ data.trandate | date }}
        </div>
      </div>
      <div class="header-item">
        <div class="label">Check #</div>
        <div class="value">
          {{ data.chequeno || '—' }}
        </div>
      </div>
      <div class="header-item">
        <div class="label">Tag</div>
        <div class="value">
          {{ data.tag || '—' }}
        </div>
      </div>
    </div>
  </div>

  <div class="amounts-card">
    <table class="amounts-table">
      <thead>
        <tr>
          <th class="text-right">Debit</th>
          <th class="text-right">Credit</th>
          <th class="text-right">Balance</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td class="text-right amount">{{ data.debit | currency }}</td>
          <td class="text-right amount">{{ data.credit | currency }}</td>
          <td class="text-right amount">{{ data.balance | currency }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="description-card" *ngIf="data.narrative">
    <div class="label">Description</div>
    <div class="description-text">
      {{ data.narrative }}
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button color="primary" (click)="close()">Close</button>
</mat-dialog-actions>


